export const keyCodes = {
  downArrow: 40,
  enter: 13,
  shift: 16,
  tab: 9,
  upArrow: 38,
};
